import React from 'react';
import { StepProps } from '../../types/form';
import { FormField } from '../ui/FormField';
export function AboutGroupStep({
  formData,
  updateFormData,
  errors
}: StepProps) {
  return <div className="space-y-6" data-id="element-32">
      <div data-id="element-33">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-34">
          About the group
        </h2>
        <p className="text-sm text-muted-foreground" data-id="element-35">
          Tell us who you are and provide basic details about the group you are
          requesting.
        </p>
      </div>

      {/* Submitter Info */}
      <div className="bg-muted/30 border border-border rounded-md p-4 space-y-4" data-id="element-36">
        <h3 className="text-sm font-semibold text-foreground" data-id="element-37">
          Your Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-38">
          <FormField id="submitterName" label="Your name" required error={errors.submitterName} data-id="element-39">
            
            <input id="submitterName" type="text" value={formData.submitterName} onChange={e => updateFormData({
            submitterName: e.target.value
          })} className={`
                w-full px-3 py-2 bg-background border rounded-md text-sm shadow-sm placeholder:text-muted-foreground
                focus:outline-none focus:ring-2 focus:ring-ring
                ${errors.submitterName ? 'border-destructive' : 'border-input'}
              `} placeholder="e.g. Jane Smith" aria-invalid={!!errors.submitterName} data-id="element-40" />
            
          </FormField>

          <FormField id="submitterEmail" label="Your email" required error={errors.submitterEmail} data-id="element-41">
            
            <input id="submitterEmail" type="email" value={formData.submitterEmail} onChange={e => updateFormData({
            submitterEmail: e.target.value
          })} className={`
                w-full px-3 py-2 bg-background border rounded-md text-sm shadow-sm placeholder:text-muted-foreground
                focus:outline-none focus:ring-2 focus:ring-ring
                ${errors.submitterEmail ? 'border-destructive' : 'border-input'}
              `} placeholder="e.g. jane@company.com" aria-invalid={!!errors.submitterEmail} data-id="element-42" />
            
          </FormField>
        </div>
      </div>

      {/* Group Info */}
      <FormField id="groupDescription" label="Who is this group for?" required hint="e.g. partner name, client, internal team, pilot" error={errors.groupDescription} data-id="element-43">
        
        <input id="groupDescription" type="text" value={formData.groupDescription} onChange={e => updateFormData({
        groupDescription: e.target.value
      })} className={`
            w-full px-3 py-2 bg-background border rounded-md text-sm shadow-sm placeholder:text-muted-foreground
            focus:outline-none focus:ring-2 focus:ring-ring
            ${errors.groupDescription ? 'border-destructive' : 'border-input'}
          `} placeholder="Enter group description" aria-invalid={!!errors.groupDescription} aria-describedby={errors.groupDescription ? 'groupDescription-error' : undefined} data-id="element-44" />
        
      </FormField>
    </div>;
}